var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 510.569 510.569",
    style: {
      enableBackground: "new 0 0 510.569 510.569"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8EDEE"
    },
    d: "M415.294,108.03c-2.299,0-4.599-0.88-6.351-2.632c-3.512-3.512-3.512-9.198,0-12.701l31.762-31.753 c3.503-3.512,9.189-3.512,12.701,0c3.503,3.503,3.503,9.198,0,12.701l-31.762,31.753C419.893,107.15,417.593,108.03,415.294,108.03 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D55B"
    },
    d: "M350.316,470.864c0,4.958-4.024,8.982-8.982,8.982c-4.958,0-8.982-4.024-8.982-8.982 c0-4.958,4.024-8.982,8.982-8.982C346.292,461.881,350.316,465.906,350.316,470.864"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D55B"
    },
    d: "M35.93,264.267c0,4.958-4.024,8.982-8.982,8.982s-8.982-4.024-8.982-8.982s4.024-8.982,8.982-8.982 S35.93,259.309,35.93,264.267"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D55B"
    },
    d: "M296.421,30.724c0,4.958-4.024,8.982-8.982,8.982s-8.982-4.024-8.982-8.982 s4.024-8.982,8.982-8.982S296.421,25.765,296.421,30.724"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D55B"
    },
    d: "M494.035,219.355c0,4.958-4.024,8.982-8.982,8.982c-4.958,0-8.982-4.024-8.982-8.982 s4.024-8.982,8.982-8.982C490.011,210.373,494.035,214.397,494.035,219.355"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D55B"
    },
    d: "M39.649,452.899l14.246,14.246l14.246-14.246l-14.246-14.246L39.649,452.899z M53.896,492.548 l-39.649-39.649l39.649-39.649l39.649,39.649L53.896,492.548z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D55B"
    },
    d: "M53.895,434.934c-4.958,0-8.982-4.024-8.982-8.982v-17.965c0-4.958,4.024-8.982,8.982-8.982 s8.982,4.024,8.982,8.982v17.965C62.877,430.91,58.853,434.934,53.895,434.934"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D55B"
    },
    d: "M98.807,461.881H80.842c-4.958,0-8.982-4.024-8.982-8.982c0-4.958,4.024-8.982,8.982-8.982h17.965 c4.958,0,8.982,4.024,8.982,8.982C107.789,457.857,103.765,461.881,98.807,461.881"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D55B"
    },
    d: "M53.895,506.794c-4.958,0-8.982-4.024-8.982-8.982v-17.965c0-4.958,4.024-8.982,8.982-8.982 s8.982,4.024,8.982,8.982v17.965C62.877,502.77,58.853,506.794,53.895,506.794"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D55B"
    },
    d: "M26.947,461.881H8.982c-4.958,0-8.982-4.024-8.982-8.982c0-4.958,4.024-8.982,8.982-8.982h17.965 c4.958,0,8.982,4.024,8.982,8.982C35.93,457.857,31.906,461.881,26.947,461.881"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#434C6D"
    },
    points: "104.069,118.104 34.203,86.342 116.77,3.775 186.636,35.537  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#434C6D"
    },
    points: "205.694,219.729 135.828,187.967 218.395,105.4 288.26,137.162  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8697CB"
    },
    points: "104.069,118.104 135.831,187.97 218.398,105.403 186.636,35.537  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8EDEE"
    },
    d: "M241.687,319.238l-46.583-46.583c-11.686-11.686-11.686-30.648,0-42.343l97.397-97.388 c11.695-11.695,30.648-11.695,42.343,0l46.574,46.583c11.695,11.686,11.695,30.648,0,42.334l-97.388,97.397 C272.335,330.933,253.383,330.933,241.687,319.238"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#434C6D"
    },
    points: "396.24,410.275 428.002,480.141 510.569,397.574 478.807,327.709  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#434C6D"
    },
    points: "294.616,308.651 326.378,378.516 408.944,295.949 377.182,226.084  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8697CB"
    },
    points: "396.24,410.275 326.375,378.514 408.942,295.947 478.807,327.709  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B6BB"
    },
    d: "M358.131,41.885c-31.573,31.573-31.573,82.755,0,114.329s82.755,31.573,114.329,0L358.131,41.885z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434C6D"
    },
    d: "M485.162,67.291c-10.527,10.527-27.585,10.527-38.113,0c-10.518-10.527-10.518-27.585,0-38.113 c10.527-10.518,27.585-10.518,38.113,0C495.69,39.706,495.69,56.764,485.162,67.291"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B0B6BB"
    },
    points: "237.451,391.221 123.123,276.892 186.637,264.191 250.152,327.706  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B0B6BB"
    },
    points: "262.858,289.596 224.746,251.484 313.672,162.566 351.784,200.67  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "300.969,251.486 262.856,213.374 275.557,200.673 313.67,238.785  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8EDEE"
    },
    d: "M212.043,340.408l-12.701,12.701l12.701,12.701l12.701-12.701c3.512-3.512,3.512-9.198,0-12.701 C221.233,336.896,215.547,336.896,212.043,340.408"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8EDEE"
    },
    d: "M186.64,315.004l-12.701,12.701l0,0l12.701,12.701l0,0l12.701-12.701 c3.512-3.512,3.512-9.189,0-12.701C195.829,311.492,190.152,311.492,186.64,315.004"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8EDEE"
    },
    d: "M161.231,315L161.231,315l12.701-12.701c3.512-3.512,3.512-9.198,0-12.701 c-3.503-3.512-9.189-3.512-12.701,0l-12.701,12.701l0,0L161.231,315z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.43c3ff83dbb78bbb8b8bc74a6dfa8c1f.svg";
export { ForwardRef as ReactComponent };